import React from 'react'

function InstagramIcon () {
  return (
    <div>
      <svg
        id='Instagram_logo_2016'
        xmlns='http://www.w3.org/2000/svg'
        width='38'
        height='38'
        viewBox='0 0 38 38'
      >
        <defs>
          <radialGradient
            id='radial-gradient'
            cx='0.266'
            cy='1.077'
            r='0.991'
            gradientTransform='translate(-2.918 5.666) rotate(-90) scale(1 0.93)'
            gradientUnits='objectBoundingBox'
          >
            <stop offset='0' stop-color='#fd5' />
            <stop offset='0.1' stop-color='#fd5' />
            <stop offset='0.5' stop-color='#ff543e' />
            <stop offset='1' stop-color='#c837ab' />
          </radialGradient>
          <radialGradient
            id='radial-gradient-2'
            cx='-0.168'
            cy='0.072'
            r='0.443'
            gradientTransform='matrix(0.196, 0.981, -4.042, 0.809, 15.634, -0.42)'
            gradientUnits='objectBoundingBox'
          >
            <stop offset='0' stop-color='#3771c8' />
            <stop offset='0.128' stop-color='#3771c8' />
            <stop offset='1' stop-color='#60f' stop-opacity='0' />
          </radialGradient>
        </defs>
        <path
          id='Path_16295'
          data-name='Path 16295'
          d='M19,0C11.07,0,8.751.008,8.3.046A9.424,9.424,0,0,0,4.555.987a7.585,7.585,0,0,0-2.183,1.6,8.157,8.157,0,0,0-2.2,4.622A34.308,34.308,0,0,0,0,12.817c0,1.513,0,3.5,0,6.176,0,7.928.009,10.246.047,10.7a9.548,9.548,0,0,0,.906,3.672A8,8,0,0,0,6.138,37.6a13.476,13.476,0,0,0,2.759.365c.471.02,5.266.035,10.065.035s9.6-.006,10.056-.029a12.977,12.977,0,0,0,2.858-.374,7.956,7.956,0,0,0,5.187-4.248,9.391,9.391,0,0,0,.9-3.6c.026-.327.037-5.548.037-10.761s-.012-10.425-.037-10.752A9.286,9.286,0,0,0,37.045,4.6,7.533,7.533,0,0,0,35.419,2.37a8.2,8.2,0,0,0-4.626-2.2A34.232,34.232,0,0,0,25.187,0Z'
          transform='translate(0.003)'
          fill='url(#radial-gradient)'
        />
        <path
          id='Path_16296'
          data-name='Path 16296'
          d='M19,0C11.07,0,8.751.008,8.3.046A9.424,9.424,0,0,0,4.555.987a7.585,7.585,0,0,0-2.183,1.6,8.157,8.157,0,0,0-2.2,4.622A34.308,34.308,0,0,0,0,12.817c0,1.513,0,3.5,0,6.176,0,7.928.009,10.246.047,10.7a9.548,9.548,0,0,0,.906,3.672A8,8,0,0,0,6.138,37.6a13.476,13.476,0,0,0,2.759.365c.471.02,5.266.035,10.065.035s9.6-.006,10.056-.029a12.977,12.977,0,0,0,2.858-.374,7.956,7.956,0,0,0,5.187-4.248,9.391,9.391,0,0,0,.9-3.6c.026-.327.037-5.548.037-10.761s-.012-10.425-.037-10.752A9.286,9.286,0,0,0,37.045,4.6,7.533,7.533,0,0,0,35.419,2.37a8.2,8.2,0,0,0-4.626-2.2A34.232,34.232,0,0,0,25.187,0Z'
          transform='translate(0.003)'
          fill='url(#radial-gradient-2)'
        />
        <path
          id='Path_16297'
          data-name='Path 16297'
          d='M31.873,18c-3.767,0-4.24.016-5.72.084a10.176,10.176,0,0,0-3.367.645,7.1,7.1,0,0,0-4.058,4.058,10.14,10.14,0,0,0-.644,3.368c-.066,1.48-.084,1.954-.084,5.722s.017,4.24.084,5.721a10.2,10.2,0,0,0,.644,3.368,7.1,7.1,0,0,0,4.056,4.06,10.185,10.185,0,0,0,3.367.645c1.48.067,1.952.084,5.719.084s4.239-.016,5.719-.084a10.191,10.191,0,0,0,3.369-.645,7.109,7.109,0,0,0,4.057-4.06A10.29,10.29,0,0,0,45.66,37.6c.066-1.48.084-1.952.084-5.721s-.017-4.242-.084-5.722a10.285,10.285,0,0,0-.644-3.368,7.1,7.1,0,0,0-4.058-4.059,10.208,10.208,0,0,0-3.37-.645c-1.48-.067-1.951-.084-5.719-.084Zm-1.244,2.5h1.244c3.7,0,4.143.013,5.605.08a7.677,7.677,0,0,1,2.576.478,4.6,4.6,0,0,1,2.632,2.634,7.67,7.67,0,0,1,.478,2.576c.066,1.463.081,1.9.081,5.606s-.014,4.143-.081,5.606a7.678,7.678,0,0,1-.478,2.576,4.6,4.6,0,0,1-2.632,2.632,7.649,7.649,0,0,1-2.576.478c-1.462.067-1.9.081-5.605.081s-4.143-.014-5.605-.081a7.692,7.692,0,0,1-2.576-.478,4.6,4.6,0,0,1-2.633-2.633,7.67,7.67,0,0,1-.478-2.576c-.066-1.463-.08-1.9-.08-5.608s.013-4.143.08-5.606a7.686,7.686,0,0,1,.478-2.577,4.6,4.6,0,0,1,2.633-2.634,7.661,7.661,0,0,1,2.576-.478c1.28-.058,1.776-.075,4.361-.078Zm8.649,2.3a1.665,1.665,0,1,0,1.665,1.665,1.665,1.665,0,0,0-1.665-1.665Zm-7.4,1.946A7.126,7.126,0,1,0,39,31.877a7.126,7.126,0,0,0-7.123-7.127Zm0,2.5a4.626,4.626,0,1,1-4.624,4.626A4.625,4.625,0,0,1,31.873,27.252Z'
          transform='translate(-12.875 -12.877)'
          fill='#fff'
        />
      </svg>
    </div>
  )
}

export default InstagramIcon
